import { types } from 'mobx-state-tree'

import {
  generateValueTypeWithLimits,
  generateEnumValue,
  generateEnumReferenceValue,
  Unit
} from 'src/api/models/Values/index'

const values = ['topLeft', 'topRight', 'bottom']

type CornerRadiusValue =
  | number
  | [number, number, number, number]
  | [number, number, number, number, number, number, number, number]

export const CornerRadius = types
  .model('CornerRadius')
  .props({
    value: types.optional(
      types.union(types.number, types.array(types.number)),
      0
    ),
    unit: types.optional(Unit, 'mm')
  })
  .actions((self) => ({
    update(value: CornerRadiusValue) {
      self.value = value
    }
  }))
